// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yIyH","colBig":"styles_colBig__3YnTm","colSmall":"styles_colSmall__29QS3"};